var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portal',{attrs:{"to":"modal"}},[_c('Transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loader"},[_c('img',{staticClass:"loader__img",attrs:{"src":"/img/common/loader.svg","alt":"loader"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }